import React, { useState } from "react";
import classNames from "classnames";

import { PillInputBox } from "../../components/forms/form-inputs";
import { AppSwitch } from "../../components/utilities/switcher";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/app-alert";
import { LoadingIndicator } from "../../components/utilities/loader";

export const SignupPage = () => {

    const{ userRegistration, isLoading } = useAuth();

    const [switched, setSwitched] = useState(false);
    const [userData, setuserData] = useState({
        email: '',
        firstname: '',
        lastname: '',
        password: '',
        repeatPassword: '',
        username: '',
        avatar: null
    });
    const [onAlert, setOnAlert] = useState();
    const [PassError, setPassError] = useState(false);

    const handleInput = (e) => {
        const nm = e.target.name
        setuserData((data) => ({...data, [nm]: e.target.value}))
    }

    const isInvalid = (v) => v === '' || v === undefined || v === null;

    const handleValidateData = () => {
        const requiredFields = ['email', 'firstname', 'username', 'password'];
        const invalidData = requiredFields.some((field) => isInvalid(userData[field]));
        if (invalidData) {
            setOnAlert({
                caption: "Error",
                message: 'Please provide data for all required fields',
            });
            return false;
        }
        return true;
    }

    const handleValidatePassword = () => {
        const { password, repeatPassword } = userData;
        if (password !== repeatPassword) {
            setOnAlert({
                caption: "Error",
                message: 'Passwords do not match! View passwords to correct this.',
            });
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!handleValidateData()){
            return;
        }
        if (!handleValidatePassword()) {
            return;
        }
        const res = await userRegistration(userData);
        if (res?.error){
            setOnAlert({
                caption: "Error",
                message: res?.error
            })
            return;
        }
        setOnAlert({
            caption: "Success",
            message: res?.message
        })
    }

    return (
        <div className={classNames("flx-cnt-pg", "full-v")}>
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={"Ok"}
                    onAccept={() => setOnAlert()}
                    closeAlert={() => setOnAlert()}
                />
            )}
            {isLoading && <LoadingIndicator />}
            <div className={classNames("cap","lg-txt")}>Welcome to PathFinders eSTEM Hub</div>
            <div className="sm-sp" />
            <div className={classNames("cap","lg-txt")}>Create an account and join us</div>
            <div className="md-sp" />
            <form className="sign-in" onSubmit={handleSubmit}>
                <div className="flx-c-rw">
                    <div className="req" >*</div> = 
                    <div className="input-caption">required</div>
                </div>
                <PillInputBox
                    type={"email"}
                    caption={"email"}
                    placeholder={"e.g mymail@provider.com"}
                    onChange={(e) => handleInput(e)}
                    name={"email"}
                    required={true}
                />
                <PillInputBox
                    type={"text"}
                    caption={"username"}
                    placeholder={"Choose your username"}
                    onChange={(e) => handleInput(e)}
                    name={"username"}
                    required={true}
                />
                <PillInputBox
                    type={"text"}
                    caption={"First Name"}
                    placeholder={"Your family name or first name"}
                    onChange={(e) => handleInput(e)}
                    name={"firstname"}
                    required={true}
                />
                <PillInputBox
                    type={"text"}
                    caption={"Last Name"}
                    placeholder={"Your given name or last name"}
                    onChange={(e) => handleInput(e)}
                    name={"lastname"}
                />
                <PillInputBox
                    type={switched ? "text" : "password"}
                    caption={"Password"}
                    placeholder={"Choose a strong password (at least 8 characters)"}
                    onChange={(e) => {
                        handleInput(e);
                        if (e.target.value.length < 8) { setPassError(true)}
                        else setPassError(false);
                    }}
                    name={'password'}
                    required={true}
                />
                {PassError && 
                    <div className="p-error">
                        {"Password is too short"}
                    </div>
                }
                <PillInputBox
                    type={switched ? "text" : "password"}
                    caption={"Confirm password"}
                    placeholder={"Repeat your password"}
                    onChange={(e) => handleInput(e)}
                    name={'repeatPassword'}
                />
                <div className="flx-c-rw">
                    <AppSwitch
                        switchedIcon={faEye}
                        unswitchedIcon={faEyeSlash}
                        switchedColor={"#340634"}
                        unswitchedColor={"#dedede"}
                        onSwitch={() => setSwitched((v) => !v)}
                    />
                    <div className={classNames("cap","sm-txt")}>
                        {switched ? "Hide password" : "Show password"}
                    </div>
                </div>
                
                <button 
                    className={classNames(
                        "form-button",
                        'pill-input-box',
                        {'disabled': PassError}
                    )}
                    disabled={PassError}
                >
                    Submit
                </button>
            </form>
        </div>
    )
}